/**
 * Inform two values to return percentage of then
 * @param {number} current Reference of current amount based on total value
 * @param {number} total Inform total vale
 * @return {number} Percentage of currnet/total
 */
export function getPercentageOf(current: number, total: number): number {
    if (typeof current !== 'number' || typeof total !== 'number') return NaN

    return (current * 100) / total
}
